<div class="main-container">
    <app-loader [isLoading]="loading"></app-loader>
    <div class="appointment-container">
        <div>
            <app-customer-boooking-header [data]="headerData"></app-customer-boooking-header>
        </div>
        <div class="wbg">
            <div *ngIf="!isMobileView" class="row">
                <div class="col-8">
                    <div class="col">
                        <label *ngIf="isMemberVisible && category?.length" class="header-label">Select category, {{categoryLabelName}}, date and time</label>
                        <label *ngIf="isMemberVisible && !category?.length" class="header-label">Select {{categoryLabelName}}, date and time</label>
                        <label *ngIf="!isMemberVisible && category?.length" class="header-label">Select category, date and time</label>
                        <label *ngIf="!isMemberVisible && !category?.length" class="header-label">Select date and time</label>

                        <div *ngIf="category?.length || isMemberVisible" class="row m-0 mt-3">
                            <select *ngIf="category.length" class="min-w form-control" [(ngModel)]="selectedCategory"
                                [ngClass]="{'red-error-class' : isSubmitted && !selectedCategory}"
                                (ngModelChange)="onChangeCategory($event)">
                                <option [value]="null" selected disabled>Select Category</option>
                                <option *ngFor="let cat of category" [value]="cat.category_id">
                                    {{ cat.category_name }}
                                </option>
                            </select>
                            <select *ngIf="isMemberVisible" class="min-w ml-2 form-control" [(ngModel)]="selectedPerson"
                                [ngClass]="{'red-error-class' : isSubmitted && !selectedPerson}"
                                (ngModelChange)="onChangeMember($event)">
                                <option [value]="null" selected disabled>Select {{categoryLabelName}}</option>
                                <option *ngFor="let member of members" [value]="member.manager_id">
                                    {{ member.name }}
                                </option>
                            </select>
                        </div>
                        <div class="row m-0 mt-5">
                            <div class="col-7">
                                <div class="mr-2">
                                    <div class="row m-0 month-row mb-2">
                                        <div class="col-1">
                                            <div class="d-flex rotate-180 left-arrow" mwlCalendarPreviousView
                                                [view]="view" [(viewDate)]="viewDate"
                                                (viewDateChange)="closeOpenMonthViewDay()">
                                                <img class="image" src="./../../assets/images/right-arrow-circular-button.svg" alt="prev">
                                            </div>
                                        </div>
                                        <div class="col-10 text-center">
                                            <div mwlCalendarToday [(viewDate)]="viewDate">
                                                {{ viewDate | calendarDate:(view + 'ViewTitle')}}
                                            </div>
                                        </div>
                                        <div class="col-1">
                                            <div class="d-flex right-arrow" mwlCalendarNextView
                                                [view]="view" [(viewDate)]="viewDate"
                                                (viewDateChange)="closeOpenMonthViewDay()">
                                                <img class="image" src="./../../assets/images/right-arrow-circular-button.svg" alt="next">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row m-0 w-100">
                                        <div class="col">Sun</div>
                                        <div class="col">Mon</div>
                                        <div class="col">Tue</div>
                                        <div class="col">Wed</div>
                                        <div class="col">Thu</div>
                                        <div class="col">Fri</div>
                                        <div class="col">Sat</div>
                                    </div>
                                    <mwl-calendar-month-view class="w-100" [viewDate]="viewDate" [refresh]="refresh"
                                        (dayClicked)="dayClicked($event.day)" (beforeViewRender)="beforeMonthViewRender($event)">
                                    </mwl-calendar-month-view>
                                </div>

                                <div *ngIf="isSubmitted && (!this.selectedDate || !this.selectedSlot || this.isSlotError)">
                                    <label class="red-error-text">Please select valid date and time</label>
                                </div>
                            </div>
                            <div class="col-5 fix-h">
                                <ngx-loading [show]="isSlotOnlyLoading"></ngx-loading>
                                <div class="row m-0" *ngIf="!isSlotError">
                                    <div class="col-6 p-0" *ngFor="let slot of timeSlots; let i=index">
                                        <div class="slots" [ngClass]="{'active-slot': slot.active}" (click)="selectSlot(i)">{{show12HrTime(slot.slot_time)}}</div>
                                    </div>
                                </div>

                                <div class="row m-0 p-2 h-100" *ngIf="isSlotError">
                                    <div class="border-error-layout">
                                        <label class="slot-date-error"> Sorry! No slots are available for the {{bookingDetails.date}}.</label>
                                        <hr class="my-2">
                                        <label class="slot-error-label" *ngIf="!isMemberVisible"> Please try a different Date or Personnel</label>
                                        <label class="slot-error-label" *ngIf="isMemberVisible"> Please try a different Date or {{categoryLabelName}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row m-0 mt-5 mb-2 jus-c">
                            <button *ngIf="isCancelVisible" class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                            <button class="btn-nxt ml-1" (click)="goNext()">Next</button>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <app-booking-detail class="h-100" [bookingData]="bookingDetails" [showVideoConf]="showVideoConf"
                        [isMemberVisible]="isMemberVisible" [isCategoryVisible]="isCategoryVisible" [isInquiry]="false">
                    </app-booking-detail>
                </div>
            </div>
            <div *ngIf="isMobileView" class="row">
                <div class="col">
                    <label *ngIf="isMemberVisible && category?.length" class="header-label">Select category, {{categoryLabelName}}, date and time</label>
                    <label *ngIf="isMemberVisible && !category?.length" class="header-label">Select {{categoryLabelName}}, date and time</label>
                    <label *ngIf="!isMemberVisible && category?.length" class="header-label">Select category, date and time</label>
                    <label *ngIf="!isMemberVisible && !category?.length" class="header-label">Select date and time</label>
                    <div class="row m-0 mt-3">
                        <select *ngIf="category?.length" class="col-5 form-control" [(ngModel)]="selectedCategory"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedCategory}"
                            (ngModelChange)="onChangeCategory($event)">
                            <option [value]="null" selected disabled>Select Category</option>
                            <option *ngFor="let cat of category" [value]="cat.category_id">
                                {{ cat.category_name }}
                            </option>
                        </select>
                        <div class="col-1"></div>
                        <select *ngIf="isMemberVisible" class="col-5 form-control" [(ngModel)]="selectedPerson"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedPerson}"
                            (ngModelChange)="onChangeMember($event)">
                            <option [value]="null" selected disabled>Select {{categoryLabelName}}</option>
                            <option *ngFor="let member of members" [value]="member.manager_id">
                                {{ member.name }}
                            </option>
                        </select>
                    </div>
                    <div class="row m-0 mt-5 mb-3 month-row">
                        <div class="col-1">
                            <div class="d-flex rotate-180 left-arrow" mwlCalendarPreviousView
                                [view]="view" [(viewDate)]="viewDate"
                                (viewDateChange)="closeOpenMonthViewDay()">
                                <img class="image" src="./../../assets/images/right-arrow-circular-button.svg" alt="prev">
                            </div>
                        </div>
                        <div class="col-10 text-center">
                            <div mwlCalendarToday [(viewDate)]="viewDate">
                                {{ viewDate | calendarDate:(view + 'ViewTitle')}}
                            </div>
                        </div>
                        <div class="col-1">
                            <div class="d-flex right-arrow" mwlCalendarNextView
                                [view]="view" [(viewDate)]="viewDate"
                                (viewDateChange)="closeOpenMonthViewDay()">
                                <img class="image" src="./../../assets/images/right-arrow-circular-button.svg" alt="next">
                            </div>
                        </div>
                    </div>
                    <div class="row m-0">
                        <div class="col">S</div>
                        <div class="col">M</div>
                        <div class="col">T</div>
                        <div class="col">W</div>
                        <div class="col">T</div>
                        <div class="col">F</div>
                        <div class="col">S</div>
                    </div>
                    <div class="row m-0">
                        <mwl-calendar-month-view class="w-100" [viewDate]="viewDate" [refresh]="refresh"
                            (dayClicked)="dayClicked($event.day)" (beforeViewRender)="beforeMonthViewRender($event)">
                        </mwl-calendar-month-view>
                    </div>
                    <div class="row m-0 mt-3 text-center jus-c" *ngIf="selectedDate && !isSlotError">
                        <label>Selected Date: {{selectedDate}}</label>
                    </div>
                    <div class="row m-0 mt-3" *ngIf="!isSlotError">
                            <div class="col-4 p-0" *ngFor="let slot of timeSlots; let i=index">
                                <div class="slots" [ngClass]="{'active-slot': slot.active}" (click)="selectSlot(i)">{{show12HrTime(slot.slot_time)}}</div>
                            </div>
                            <div *ngIf="isSubmitted && !selectedDate">
                                <label class="red-error-text">Please select valid date and time</label>
                            </div>
                    </div>
                    <div class="row m-0 mt-4" *ngIf="isSlotError">
                        <div class="border-error-layout">
                          <label class="slot-date-error"> Sorry! No slots are available for the {{bookingDetails.date}}.</label>
                          <hr class="my-2">
                          <label class="slot-error-label" *ngIf="!isMemberVisible"> Please try a different Date or Personnel</label>
                          <label class="slot-error-label" *ngIf="isMemberVisible"> Please try a different Date or {{categoryLabelName}}</label>
                        </div>
                    </div>
                    <div class="row m-0 mt-5 mb-2 jus-c">
                        <button *ngIf="isCancelVisible" class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                        <button class="btn-nxt ml-1" (click)="goNext()">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <app-footer-powered-by-image></app-footer-powered-by-image>
    </div>
</div>
